module.exports = __webpack_public_path__ + "img/b8.85ab38a0.png";